import type { CharacterStat } from '../types';

export function StatisticDisplay({ stats }: { stats: CharacterStat[] }) {
  return (
    <section className="stats" aria-labelledby="stats-heading">
      <h2 id="stats-heading">Combat readout</h2>
      <div className="stats__list">
        {stats.map((stat) => (
          <div className="stat" key={stat.label}>
            <div className="stat__label"><span>{stat.label}</span><b>{stat.value}</b></div>
            <div className="stat__track" aria-label={`${stat.label}: ${stat.value} out of 100`}><i style={{ width: `${stat.value}%` }} /></div>
          </div>
        ))}
      </div>
    </section>
  );
}
